import React, { useContext, useEffect } from "react";
import DocumentVerificationStats from "components/DocumentVerificationStats";
import { DocumentsContext } from "features/documents";

export default function DocumentVerificationStatsPage() {
  const { statsForDocRequested, statForAllDocRequested } = useContext(
    DocumentsContext
  );

  useEffect(() => {
   statForAllDocRequested()
  }, []);
  return <DocumentVerificationStats data={statsForDocRequested} />
}
